"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchToggleMenu = void 0;
var _toggleMenuFlyout = require("@ori-events/toggle-menu-flyout");
const event = menuType => new CustomEvent(_toggleMenuFlyout.Name, {
  detail: {
    menuType
  }
});
const dispatchToggleMenu = (menuToggle, activeMenu = '') => {
  if (activeMenu !== '' && menuToggle !== activeMenu) {
    window.dispatchEvent(event(activeMenu));
  }
  requestAnimationFrame(() => {
    window.dispatchEvent(event(menuToggle));
  });
};
exports.dispatchToggleMenu = dispatchToggleMenu;
